export const GLOW_VERTEX_SHADER = `
  uniform float c;
  uniform float p;
  varying float intensity;
  void main()
  {
      vec4 worldPosition = modelViewMatrix * vec4( position, 1.0 );

      vec3 viewVector = worldPosition.xyz - cameraPosition;
      vec3 vNormal = normalize( normalMatrix * normal );
      vec3 vNormel = normalize( normalMatrix * viewVector );
      //intensity = pow( c - dot(vNormal, vNormel), p );

      intensity = 1.0;

      gl_Position = projectionMatrix * worldPosition;
  }`;
export const GLOW_FRAGMENT_SHADER = `
  uniform vec3 glowColor;
  uniform float glowOpacity;
  varying float intensity;

  void main()
  {
      vec3 glow = glowColor * intensity;
      gl_FragColor = vec4( glow, glowOpacity );
  }`;
export const TOOLTIP_VERTEX_SHADER = `
  varying vec2 vUv;
  varying vec3 vColor;

  void main()
  {
      vUv = uv;
      vColor = color;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
  }`;
export const TOOLTIP_FRAGMENT_SHADER = `
  uniform float time;
  uniform sampler2D texture;
  varying vec2 vUv;
  varying vec3 vColor;

  void main()
  {
      float xCoords = vUv.x;
      float yPartYCoords = cos( vUv.y + time * -0.5) * 0.5;
      float xPartYCoords = sin( vUv.x + time * 0.1) * 0.5;

      vec2 newUv = vec2( xCoords, sin(yPartYCoords * xPartYCoords) *0.5 + 0.5);

      vec4 tex = texture2D( texture, newUv );

      float red = sin( time ) * 0.2 + 0.5;
      float green = cos( time ) * 0.2 + 0.5;
      float blue = 1.0;;
      //gl_FragColor = vec4( vColor.x, 0.0, 0.0, vColor.x);
      gl_FragColor = vec4( tex.x * red , tex.y * green , tex.z * blue, vColor.x);
  }`;
